import { render, staticRenderFns } from "./imgBox1.vue?vue&type=template&id=9cc2cc2a&scoped=true&"
import script from "./imgBox1.vue?vue&type=script&lang=js&"
export * from "./imgBox1.vue?vue&type=script&lang=js&"
import style0 from "./imgBox1.vue?vue&type=style&index=0&id=9cc2cc2a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cc2cc2a",
  null
  
)

export default component.exports